

























































































export default {
  data() {
    return {
      username: '',
      password: '',
      isAttemptingWifiSetup: false,
      hasAttemptedWifiSetup: false,
      hasSuccessfulWifiSetup: false,
      showWifiSetupAttemptSnackbar: false,
      fieldRules: [v => !!v || 'This field is required'],
      fieldsAreValid: false,
    }
  },
  computed: {
    actionButton() {
      return {
        text: this.hasSuccessfulWifiSetup ? 'Done' : 'Connect',
        isDisabled: !this.fieldsAreValid || this.isAttemptingWifiSetup,
        isLoading: this.isAttemptingWifiSetup,
        action: this.hasSuccessfulWifiSetup ? this.resetStage : this.rebootGateway,
      }
    },
    wifiSetupAttemptNotice() {
      return {
        showNotice: this.hasAttemptedWifiSetup,
        color: this.hasSuccessfulWifiSetup ? 'green' : 'red',
        icon: this.hasSuccessfulWifiSetup ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
        text: this.hasSuccessfulWifiSetup ? 'WIFI successfully connected' : 'WIFI failed to connect',
      }
    },
    wifiSetupAttemptSnackbar() {
      return {
        color: this.hasSuccessfulWifiSetup ? 'green' : 'red',
        icon: this.hasSuccessfulWifiSetup ? 'mdi-check-circle' : 'mdi-close-circle',
        title: this.hasSuccessfulWifiSetup ? 'Success' : 'Error',
        text: this.hasSuccessfulWifiSetup
          ? 'WIFI successfully connected'
          : 'Cannot connect to WIFI. User or password may be incorrect, please try again',
      }
    },
  },

  methods: {
    async rebootGateway() {
      try {
        console.info('this function will attempt to connect to WIFI')
        this.closeWifiSetupAttemptSnackbar()
        this.isAttemptingWifiSetup = true
        setTimeout(() => {
          this.isAttemptingWifiSetup = false
          this.hasAttemptedWifiSetup = true

          this.hasSuccessfulWifiSetup = true

          //this.hasSuccessfulWifiSetup = false;

          this.showWifiSetupAttemptSnackbar = true
        }, 2000)
      } catch (err) {
        console.log(err)
      }
    },
    resetStage() {
      this.closeWifiSetupAttemptSnackbar()
      this.hasAttemptedWifiSetup = false
      this.hasSuccessfulWifiSetup = false
      this.$nextTick(() => {
        this.$refs.rebootGatewayForm.reset()
      })
    },
    openWifiSetupAttemptSnackbar() {
      this.showWifiSetupAttemptSnackbar = true
    },
    closeWifiSetupAttemptSnackbar() {
      this.showWifiSetupAttemptSnackbar = false
    },
  },
}
